import moment from 'moment';
import {
  convertDetailslistToSheet,
  prepareCsvFromXlsx,
  saveFileAsXlsx,
  saveFileAsCsv,
} from 'util/exceljs';
import { IColumn } from '@fluentui/react';
import { DownloadFileType } from './types';

/**
 * The list of options for the download file type along with the handler for each.
 */
export const saveOptionList: Record<
  DownloadFileType,
  {
    onComplete: (selectedColumnList: IColumn[], items: any[]) => void;
  }
> = {
  xlsx: {
    onComplete: (selectedColumnList: IColumn[], items: any[]) =>
      convertDetailslistToSheet(selectedColumnList, items).then(wb =>
        saveFileAsXlsx(
          `Security Updates ${moment().format('YYYY-MM-DD-hhmmssa')}.xlsx`,
          wb
        )
      ),
  },
  csv: {
    onComplete: (selectedColumnList: IColumn[], items: any[]) =>
      convertDetailslistToSheet(selectedColumnList, items).then(wb => {
        prepareCsvFromXlsx(wb, wb.worksheets[0].name);
        saveFileAsCsv(
          `Security Updates ${moment().format('YYYY-MM-DD-hhmmssa')}.csv`,
          wb
        );
      }),
  },
};
